<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商户名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入商户名称"></el-input>
					</el-form-item>
					<el-form-item label="商户编码" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.code" placeholder="请输入商户编码"></el-input>
					</el-form-item>
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item label="收支" class='tiny'>
						<el-select v-model="searchInfo.changeType" placeholder="请选择">
							<el-option key="-1" label="支出" value="-1"></el-option>
							<el-option key="1" label="收入" value="1"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						<!-- 	<el-button type="primary" @click="editialogVisible()">新增用户
                            </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>

		<!-- 	<div style="margin: 20px;">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div>
					<span style="font-weight: bold;">统计</span><span style="font-size: 12px;">(资产名称必选)</span>：
				</div>
				<div style="margin-right: 30px;">
					总金额: {{allData?allData:0 |intToFloatfour|cutZero}}
				</div>
				<div>
                    总支出: {{allData.bigDecimal1?allData.bigDecimal1:'0'}}
                </div>
			</div>
		</div>
 -->
		<div style="margin: 20px">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div><span style="font-weight: bold">统计：</span></div>
				<div>
					总数量: {{ allData ? allData : 0 | intToFloatfour | cutZero }}
				</div>
			</div>
		</div>

		<el-table class="tables" :data="userRecordList.list" stripe style="width: 100%;"
			:header-cell-style="headClass" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<el-table-column prop="storeId" label="商铺ID" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="code" label="商铺编码" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="storeName" label="商铺名称" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
		
		
		
			<el-table-column label="收支" prop="changeType" align="center" width="100" :formatter="changeNull">
				<template slot-scope="scope">
					<p v-if="scope.row.changeType==-1">支出</p>
					<p v-if="scope.row.changeType==1">收入</p>
				</template>
			</el-table-column>
			
			<el-table-column prop="amount" label="变动金额" align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="operBy" label="操作人" align="center" width="150" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
					
			<el-table-column prop="memo" label="备注" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
		
			<el-table-column prop="createTime" label="创建时间" width="150" align="center" :formatter="changeNull">
			</el-table-column>
		
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="userRecordList.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				userRecordList: [], //用户列表
				dialogVisible: false,
				typeList: [],
				integralList: [],
				integralId: "", //积分id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					
				},
				allData: '',
				total:0
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			timelist(){
				var arr=[]
				var date = new Date();
				   //年 getFullYear()：四位数字返回年份
				   var year = date.getFullYear();  //getFullYear()代替getYear()
				   //月 getMonth()：0 ~ 11
				   var month = date.getMonth() + 1;
				   //日 getDate()：(1 ~ 31)
				   var day = date.getDate();
				   //时 getHours()：(0 ~ 23)
				   var hour = date.getHours();
				   //分 getMinutes()： (0 ~ 59)
				   var minute = date.getMinutes();
				   //秒 getSeconds()：(0 ~ 59)
				   var second = date.getSeconds();
								
				   var time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
									var time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
									// console.log(time1);
									arr.unshift(time1)
									arr.unshift(time)
									return arr
			},
			//导出
			downloadFile() {
				let data = {
					changeType: this.searchInfo.changeType ? this.searchInfo.changeType : "",
			
				
					
			
					storeId: this.searchInfo.storeId ? this.searchInfo.storeId : "",
					storeName: this.searchInfo.storeName ? this.searchInfo.storeName : "",
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				//   console.log(data);				
				if (data.startTime || data.cutOffTime) {
					this.$api.assetChangesExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
				} else {
					this.$message.error('请选择时间')
				}
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "资产变动记录" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserRecordList();
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserRecordList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserRecordList()
			},
			
			getUserRecordList() {
				this.loading = true
				
				
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : '',
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : '',
					storeName: this.searchInfo.storeName,
				
					changeType: this.searchInfo.changeType,
				
				}
					// console.log(data);
				this.$api.depositlist(this.$encrypt(data)).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log(res);
					if (res.state == 'success') {
						this.userRecordList = res.data
						this.loading = false
						this.total = res.data.total
					} else {
						this.$message.error(res.message)
					}
				})
				this.$api.listSum(this.$encrypt(data)).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.allData = res.data
					}
				})
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(data).then((res) => {
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
		},
		created() {
			// console.log(this.timelist());
			this.getUserRecordList();
			this.getRecordTypeList();
			
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
